module.exports = __webpack_public_path__ + "static/media/camera_on.48c34c43.svg";